/* eslint-disable react/no-unused-state */

import * as React from "react";

import {
  InnerOverlayContextInterface,
  OverlayContext,
  OverlayContextInterface,
  OverlayTheme,
  OverlayType,
} from ".";

class Provider extends React.Component<
  { pathname: string },
  OverlayContextInterface
> {
  notificationCloseDelay = 2500;

  constructor(props) {
    super(props);
    this.state = {
      context: null,
      hide: this.hide,
      show: this.show,
      toggle: this.toggle,
      theme: null,
      type: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.pathname !== prevProps.pathname &&
      this.state.type !== OverlayType.message
    ) {
      this.hide();
    }
  }

  show = (
    type: OverlayType,
    theme?: OverlayTheme,
    context?: InnerOverlayContextInterface
  ) => {
    this.setState({ type, theme, context });
    document.body.style.overflow = type !== OverlayType.message ? "hidden" : "";
    if (type === OverlayType.message) {
      setTimeout(this.hide, this.notificationCloseDelay);
    }
  };

  hide = () => {
    this.setState({ type: null });
    document.body.style.overflow = "";
  };

  toggle = (
    type: OverlayType,
    theme?: OverlayTheme,
    context?: InnerOverlayContextInterface
  ) => {
    if (this.state.type !== type) {
      this.show(type, theme, context);
    } else {
      this.hide();
    }
  };

  render() {
    return (
      <OverlayContext.Provider value={this.state}>
        {this.props.children}
      </OverlayContext.Provider>
    );
  }
}

export default Provider;
